module.exports = __webpack_public_path__ + "assets/ic_cart-f0669b.svg";